import React from 'react';
import { DeclaredComponent } from './DynamicComponent';

export const RetrieveQuote = ({ title, content }) => {
  if (!content) return null;
  return (
    <div
      style={{
        display: 'flex',
        paddingBottom: '36px',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {title.length > 0
        ? title.map((text, index) => (
            <h1 style={{ margin: 0, marginTop: '8px' }} key={index}>
              {text.value}
            </h1>
          ))
        : null}
      <div style={{ marginTop: '24px' }}>
        <DeclaredComponent declaration={content} />
      </div>
    </div>
  );
};
